import React, { useContext } from 'react';

import FormData from './Form.context';

const ErrorMsg = ({ name }) => {
	const form = useContext(FormData);
	const { errors } = form;

	const getError = () => {
		if (name.includes('.'))
			return errors[name.split('.')[0]];
		else
			return errors[name];
	}

	const getErrorMessage = () => {
		if (name.includes('.'))
			return errors[name.split('.')[0]][name.split('.')[1]]?.message;
		else
			return errors[name]?.message || 'Invalid Input';
	}

	if (!getError())
		return null;

	return (
		<span>
			{getErrorMessage()}
		</span>
	);
};

export default ErrorMsg;
